import { TProjectsListState } from 'shared/reducers';

export const selectProjectModal = (state: TProjectsListState) => {
  return state.projectModal;
};
